<template>
  <div id="index" class="block">
    <div class="header">
      <img src="../../assets/images/tht/logo.png" alt class="logo" />
      <div class="menu">
        <ul>
          <li
            v-for="(item, index) in titleList"
            :key="index"
            :class="{ active: index === activeIndex }"
          >
            <a href="javascript:void(0)" @click="goAnchor(item.id, index)">
              {{ item.title }}
              <span class="line"></span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="carousel">
      <el-carousel height="816px" arrow="never">
        <el-carousel-item>
          <div class="carousel_banner">
            <img src="../../assets/images/tht/banner-1.png" alt />
          </div>
          <img src="../../assets/images/tht/bg.png" alt class="carousel_pic" />
        </el-carousel-item>
        <el-carousel-item>
          <div class="carousel_banner">
            <img src="../../assets/images/tht/banner-2.png" alt />
          </div>
          <img src="../../assets/images/tht/bg.png" alt class="carousel_pic" />
        </el-carousel-item>
        <el-carousel-item>
          <div class="carousel_banner">
            <img src="../../assets/images/tht/banner-3.png" alt />
          </div>
          <img src="../../assets/images/tht/bg.png" alt class="carousel_pic" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="content_box">
      <ul>
        <li v-for="(item, index) in list" :key="index" :id="item.id">
          <div class="title">
            <p class="main_title">
              {{ item.title }}
              <span class="title_line"></span>
            </p>
            <p class="sub_title">{{ item.subTitle }}</p>
          </div>
          <div class="content" v-for="(txt, i) in item.content" :key="i">
            <div>{{ txt }}</div>
            <div class="pic_list" v-if="index === 0">
              <div>
                <div class="download">
                  <img src="../../assets/images/tht/ios_down.png" alt />
                  <p>IOS下载</p>
                </div>

                <img src="../../assets/images/tht/taohuitao_logo.png" alt />
                <div class="download">
                  <img src="../../assets/images/tht/Android_down.png" alt />
                  <p>安卓下载</p>
                </div>
              </div>
              <div>
                <img src="../../assets/images/tht/1080-1920-1.png" alt />
                <img src="../../assets/images/tht/1080-1920-2.png" alt />
                <img src="../../assets/images/tht/1080-1920-3.png" alt />
                <img src="../../assets/images/tht/1080-1920-4.png" alt />
              </div>
            </div>
          </div>
        </li>
        <li></li>
        <li></li>
      </ul>
    </div>
    <div class="footer">
      Copyright © 2009-2020 搜谷科技 闽 ICP备15022903号-1.
      厦门搜谷科技有限公司 版权所有
    </div>
  </div>
</template>
<script>
// 写个注释

export default {
  name: "index",
  data() {
    return {
      activeIndex: 0,
      titleList: [
        {
          title: "首页",
          id: "index"
        },
        {
          title: "业务服务",
          id: "serve"
        },
        {
          title: "关于我们",
          id: "about"
        },
        {
          title: "联系我们",
          id: "concat"
        }
      ],
      list: [
        {
          id: "serve",
          title: "业务介绍",
          subTitle: "introduce",
          content: [
            "搜谷科技将以大数据为载体，打造超级生活入口，融合多方资源，构建分享价值网络。从而推动整个社会降低商业流通成本，提高交易效率，让消费者和商家共享效率提升的效果！整合数万的电商商家，每天多达几万的品类商品。供你分享，我们同步聚划算等多个模块。好货优选随机免单，每日爆款，还有贴心的9.9包邮。品牌闪购，大牌旗舰店等你来逛。排序方式多样化，券后价，优惠金额，奖励金额，销量等。"
          ],
          pic: [
            "../../assets/images/tht/taohuitao_logo.png",
            "../../assets/images/tht/1080-1920-1.png",
            "../../assets/images/tht/1080-1920-2.png",
            "../../assets/images/tht/1080-1920-3.png",
            "../../assets/images/tht/1080-1920-4.png"
          ]
        },
        {
          id: "about",
          title: "关于我们",
          subTitle: "About us",
          content: [
            "我们是一群热爱生活的年轻人，我们的使命是「让消费者花更少的钱买到好东西」，希望通过我们的努力能够帮助无数消费者和商家，让数亿中国普通老百姓的生活更美好。未来已来，也许没人会相信我们十年后的样子，但我们应该、也必须自己相信自己。在通往梦想的道路上，一路披荆斩棘，一起做一家伟大的「引领消费的世界级科技公司」!"
          ]
        },
        {
          id: "concat",
          title: "联系我们",
          subTitle: "Contact us",
          content: [
            "厦门搜谷科技有限公司",
            "联系地址：厦门市思明区软件园二期望海路 67 号 24 层",
            "联系邮箱： service@longyunds.com"
          ]
        }
      ]
    };
  },
  methods: {
    goAnchor(selector, i) {
      // console.log('select')
      this.activeIndex = i;
      if (i !== 0) {
        var anchor = this.$el.querySelector(`#${selector}`); // 参数为要跳转到的元素id
        document.body.scrollTop = anchor.offsetTop; // chrome
        document.documentElement.scrollTop = anchor.offsetTop; // firefox
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#index {
  background: #f4f5f9;
  .header {
    position: relative;
    width: 1093px; /*no*/
    margin: auto;
    z-index: 10;
    background: rgba(255, 255, 255, 0);
    display: flex;
    height: 130px; /*no*/
    color: #fff;
    font-size: 24px; /*no*/
    justify-content: space-between;
    .logo {
      width: 145px; /*no*/
      height: 130px; /*no*/
      font-size: 0;
    }
    .menu {
      // margin-left: 310px;
      ul {
        display: flex;
        line-height: 100%;
        li {
          a {
            color: #fff;
            display: block;
            padding: 48px 27px; /*no*/
            text-decoration: none;
          }
        }
        li:last-child {
          a {
            padding-right: 0;
          }
        }
        li.active {
          span {
            display: block;
            width: 26px; /*no*/
            height: 4px; /*no*/
            background: rgba(255, 255, 255, 1);
            border-radius: 2px; /*no*/
            margin: auto;
            margin-top: 5px; /*no*/
          }
        }
      }
    }
  }
  .carousel {
    margin-top: -130px; /*no*/
    min-width: 1093px; /*no*/
  }
  .content_box {
    width: 1093px; /*no*/
    // height: 1070px;
    // margin-bottom: 80px;
    // background: rgba(255, 255, 255, 1);
    background: #fff;
    box-shadow: 3px 7px 8px 3px rgba(0, 0, 0, 0.04); /*no*/
    border-radius: 24px; /*no*/
    margin: auto;
    padding: 72px 59px 64px 66px; /*no*/
    margin-top: -226px; /*no*/
    z-index: 9;
    position: relative;
    ul {
      li {
        margin-bottom: 71px; /*no*/
      }
    }
    .title {
      position: relative;
      text-align: center;
      height: 70px; /*no*/
      .main_title {
        color: #ff4400;
        font-size: 24px; /*no*/

        position: absolute;
        top: 19px; /*no*/
        // bottom: 1px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        margin: auto;
        .title_line {
          width: 100%;
          height: 8px; /*no*/
          display: block;
          background: linear-gradient(
            90deg,
            rgba(255, 237, 118, 1) 0%,
            rgba(251, 103, 64, 1) 100%
          );
          border-radius: 4px; /*no*/
        }
      }
      .sub_title {
        font-size: 50px; /*no*/
        font-family: PingFangSC-Semibold, PingFangSC;
        font-weight: 600;
        color: #f3f3f3;
        // line-height: 70px;
        letter-spacing: 3px; /*no*/
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 0;
      }
    }
    .content {
      font-size: 20px; /*no*/
      font-family: PingFangSC-Medium, PingFangSC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 37px; /*no*/
      letter-spacing: 1px; /*no*/
      .pic_list {
        img {
          width: 200px; /*no*/
        }
        > div {
          display: flex;
          justify-content: space-between;
          margin-top: 20px; /*no*/
        }
        > div:nth-child(1) {
          justify-content: space-around;
          img {
            width: 200px; /*no*/
            height: 200px; /*no*/
          }
          .download {
            img {
              width: 180px; /*no*/
              height: 180px; /*no*/
              font-size: 0;
            }
            p {
              line-height: 20px; /*no*/
              font-size: 16px; /*no*/
              text-align: center;
              margin: 0;
            }
          }
        }
      }
    }
    // display: none;
  }
  .footer {
    text-align: center;
    font-size: 14px; /*no*/
    font-family: PingFangSC-Regular, PingFangSC;
    font-weight: 400;
    color: rgba(170, 170, 170, 1);
    line-height: 20px; /*no*/
    margin-top: 80px; /*no*/
    padding-bottom: 39px; /*no*/
  }
}
</style>
<style lang="less">
#index {
  font-size: 20px; /*no*/
  .carousel_banner {
    width: 1093px; /*no*/
    margin: auto;
    height: 406px; /*no*/
    // border: 1px solid #000;
    margin-top: 130px; /*no*/
    margin-bottom: 130px; /*no*/

    // img {
    //   width: 100%;
    // }
    // height: 0;
    // width: 100%;
    // border-top: 817px solid red;
    // border-bottom: 37px solid transparent;
    // // transform: rotate(-15deg);
    // background: linear-gradient(
    //   90deg,
    //   rgba(255, 135, 62, 1) 0%,
    //   rgba(245, 48, 70, 1) 100%
    // );
  }
  .carousel_pic {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
  }
  .carousel {
    .el-carousel__indicator {
      bottom: 230px; /*no*/
      .el-carousel__button {
        width: 14px; /*no*/
        height: 14px; /*no*/
        border-radius: 7px; /*no*/
        background: rgba(255, 255, 255, 1);

        // opacity: 0.5;
      }
    }
    .el-carousel__indicators--horizontal {
      bottom: 230px; /*no*/
    }

    .el-carousel__item {
      background: linear-gradient(
        90deg,
        rgba(255, 135, 62, 1) 0%,
        rgba(245, 48, 70, 1) 100%
      );
    }

    .el-carousel__item:nth-child(2) {
      background: linear-gradient(
        90deg,
        rgba(255, 183, 217, 1) 0%,
        rgba(248, 130, 183, 1) 100%
      );
    }

    .el-carousel__item:nth-child(3) {
      background: linear-gradient(
        90deg,
        rgba(177, 199, 255, 1) 0%,
        rgba(110, 147, 253, 1) 100%
      );
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tht/tht.vue